// De samenstelling van de teller van Impact per euro: welke stromen erin gaan,
// wanneer er geen teller is, en wat als gekoppelde meting telt.
//
// WAAROM DIT EEN EIGEN BESTAND IS. Twee plekken stellen de teller samen — de
// hook achter de dashboardkaart en de detailpagina, die de stromen ook
// afzonderlijk toont. Toen die regel op beide plekken stond, liepen ze uit
// elkaar: de detailpagina bleef op twee stromen staan en haar knop
// 'Vastleggen' zou een kengetal bevriezen waar de materialen uit ontbraken.
// AI-CONTEXT: docs/pitfalls.md#dev-copied-recipe-instead-of-shared-hook
//
// AI-CONTEXT: See docs/methodiek-impact-per-euro.md § 1.1 en § 5.2

/**
 * @typedef {object} TellerSamenstelling
 * @property {number|null} teller - De opgetelde maatschappelijke waarde, of null zolang een stroom ontbreekt
 * @property {number} linkedMeasurementCount - Gekoppelde metingen voor de drempel van twintig
 */

/**
 * @param {object} input
 * @param {number|null} input.participationValue - Periode-delta participatieladder
 * @param {number|null} [input.participationCount] - Gekoppelde metingen uit die stroom
 * @param {number|null} input.msiValue - Periode-delta MSI-effecten
 * @param {number|null} [input.msiCount] - Persona-gekoppelde delta's uit die stroom
 * @param {number|null} input.materialValue - Maatschappelijke besparing materialen en coachadviezen
 * @returns {TellerSamenstelling}
 */
const composeTeller = (input) => {
    const {
        participationValue = null,
        participationCount = 0,
        msiValue = null,
        msiCount = 0,
        materialValue = null,
    } = input || {}

    // Alle drie moeten geladen zijn. Een teller met twee van de drie stromen
    // doet zich als compleet voor en levert een te laag kengetal op.
    const compleet = participationValue !== null && msiValue !== null && materialValue !== null

    return {
        teller: compleet ? participationValue + msiValue + materialValue : null,
        // Materialen tellen hier NIET mee: de drempel gaat over gekoppelde
        // deelnemermetingen, en een huishouden met een materiaal is er geen.
        linkedMeasurementCount: (participationCount ?? 0) + (msiCount ?? 0),
    }
}

export default composeTeller
